import { deforestationType } from 'store/typesActions/types';
import { api } from 'services/api';

export const getDeforestation = (code) => async (dispatch) => {
	dispatch({ type: deforestationType.DEFORESTATION_REC });
	try {
		const res = await api.get(`/ti/${code}/alerts_deforestation_sad`);
		const { data } = res || {};
		dispatch({
			type: deforestationType.DEFORESTATION_REC_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.status === 400) {
			const { message } = response.data;
			dispatch({
				type: deforestationType.DEFORESTATION_REC_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: deforestationType.DEFORESTATION_REC_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
